import moment from 'moment';

export const STATIC_RANGES = [
  {
    id: 'today',
    label: 'Today',
    startDate: moment().clone().startOf('day').toDate(),
    endDate: moment().clone().endOf('day').toDate()
  },
  {
    id: 'yesterday',
    label: 'Yesterday',
    startDate: moment().clone().subtract(1, 'day').startOf('day').toDate(),
    endDate: moment().clone().subtract(1, 'day').endOf('day').toDate()
  },
  {
    id: 'thisWeek',
    label: 'This Week',
    startDate: moment().clone().startOf('week').startOf('day').toDate(),
    endDate: moment().clone().endOf('week').endOf('day').toDate()
  },
  {
    id: 'lastWeek',
    label: 'Last Week',
    startDate: moment().clone().subtract(1, 'week').startOf('week').startOf('day').toDate(),
    endDate: moment().clone().subtract(1, 'week').endOf('week').endOf('day').toDate()
  },
  {
    id: 'thisMonth',
    label: 'This Month',
    startDate: moment().clone().startOf('month').startOf('day').toDate(),
    endDate: moment().clone().endOf('month').endOf('day').toDate()
  },
  {
    id: 'lastMonth',
    label: 'Last Month',
    startDate: moment().clone().subtract(1, 'month').startOf('month').startOf('day').toDate(),
    endDate: moment().clone().subtract(1, 'month').endOf('month').endOf('day').toDate()
  },
  {
    id: 'yearToDate',
    label: 'Year to Date',
    startDate: moment().clone().startOf('year').startOf('day').toDate(),
    endDate: moment().clone().endOf('day').toDate()
  },
  {
    id: 'lastYear',
    label: 'Last Year',
    startDate: moment().clone().subtract(1, 'year').startOf('year').startOf('day').toDate(),
    endDate: moment().clone().subtract(1, 'year').endOf('year').endOf('day').toDate()
  },
  {
    id: 'last12Months',
    label: 'Last 12 Months',
    startDate: moment().clone().subtract(12, 'months').startOf('day').toDate(),
    endDate: moment().clone().endOf('day').toDate()
  },
  {
    id: 'last24Months',
    label: 'Last 24 Months',
    startDate: moment().clone().subtract(24, 'months').startOf('day').toDate(),
    endDate: moment().clone().endOf('day').toDate()
  }
];
